import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

// ── "Can you take this job?" ───────────────────────────────────────────────
//
// The step that did not exist before. A job used to be assigned TO a
// technician, which meant it landed in his list whether or not he had read it,
// and whether or not he was already booked that day. Nobody found out until
// the appointment was missed.
//
// So now he is ASKED, and he answers. Two buttons, both of them fine. The
// decline is deliberately as easy as the accept: a no in ten seconds is worth
// far more to QPS than a silence that wastes six hours and becomes a no
// anyway, and a man who feels punished for declining simply stops opening the
// app.
//
// Written for a technician standing on a ladder holding a phone. Address
// first, one question, two buttons, no menus.
export default function JobOffers() {
  const { requests, vendorProfile, respondToOffer, offerBusy } = useApp();
  const [decliningId, setDecliningId] = useState(null);
  const [reason, setReason] = useState('');

  const myId = String(vendorProfile?._id || '');
  if (!myId) return null;

  const offered = (requests || []).filter((r) =>
    (r.dispatch?.offers || []).some(
      (o) => String(o.vendorId) === myId && (!o.response || o.response === 'offered'),
    ));

  if (!offered.length) return null;

  const decline = async (id) => {
    await respondToOffer(id, false, reason.trim());
    setDecliningId(null);
    setReason('');
  };

  return (
    <div className="offers">
      <div className="offers-head">
        {offered.length === 1 ? 'A job for you' : `${offered.length} jobs for you`}
      </div>

      {offered.map((r) => {
        const busy = offerBusy === r._id;
        const emergency = r.priority === 'emergency';
        const lines = (r.items || []).map((i) => i.title || i.serviceType).filter(Boolean);
        return (
          <div key={r._id} className={`offer-card${emergency ? ' urgent' : ''}`}>
            {emergency && <div className="offer-flag">Emergency</div>}

            {/* The separator is a real character, not a margin. A margin looks
                right and reads as "#412 N 100 E" to a screen reader, and to
                anyone who copies the line out. */}
            <div className="offer-where">
              {r.unitLabel && <><span className="offer-unit">{r.unitLabel}</span>{' · '}</>}
              {r.serviceAddress}
            </div>

            <div className="offer-what">
              {lines.length ? lines.join(' · ') : (r.serviceType || 'Work order')}
            </div>
            {r.description && <div className="offer-detail">{r.description}</div>}

            {decliningId === r._id ? (
              <>
                <label className="offer-label" htmlFor={`why-${r._id}`}>
                  Why not, in a few words? It helps us find the right person.
                </label>
                <input id={`why-${r._id}`} type="text" className="offer-input"
                  value={reason} onChange={(e) => setReason(e.target.value)}
                  placeholder="Booked out till Thursday" />
                <div className="offer-actions">
                  <button className="offer-btn ghost" disabled={busy}
                    onClick={() => { setDecliningId(null); setReason(''); }}>
                    Back
                  </button>
                  <button className="offer-btn no" disabled={busy} onClick={() => decline(r._id)}>
                    {busy ? 'Sending…' : 'Send it'}
                  </button>
                </div>
              </>
            ) : (
              <div className="offer-actions">
                <button className="offer-btn no" disabled={busy}
                  onClick={() => { setDecliningId(r._id); setReason(''); }}>
                  Can't do it
                </button>
                <button className="offer-btn yes" disabled={busy}
                  onClick={() => respondToOffer(r._id, true)}>
                  {busy ? 'Saving…' : "I'll take it"}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
